// extracted by mini-css-extract-plugin
module.exports = {"msg":"retailer-remove_msg_1lBPH"};